import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import HeaderDashboard from '../dashboard/header-dashboard';
import Dtable from '../dashboard/table';
import Devices from './devices';
import Service from './servicios';
import Metrics from './metrics';
import Loader from '../loader';
import { WrapperMonitoreo } from './styles';
import { getMonitoreoDevice, getMonitoreoService, getMonitoreoMetric, setMonitoreoFiltersSelected } from '../../store/fuse/monitoreo';
import { getDashboardCaidas, getDashboardResponseTime, getDashboardFirstSection, getDashboardMetrics, setDashboardFiltersSelected} from '../../store/fuse/dashboard';
import { getNotifications } from '../../theme-layouts/shared-components/notificationPanel/store/dataSlice';

import DashboardFilter from '../dashboard/filter';
import DevicesHigh from './devices/DevicesHigh';
import CaidasNodos from "../dashboard/nodes-info/log-general";
import TiempoRespuesta from "../dashboard/nodes-info/tiempo-respuesta";

function Index(props) {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();
  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];

  const [inmueble, setInmueble] = useState('');
  const [region, setRegion] = useState('');
  const [grupo, setGrupo] = useState('');
  const [nodo, setNodo] = useState('');
  const [dateInit, setDateInit] = useState();
  const [dateEnd, setDateEnd] = useState();

  const initMonitoreoDevice = (filters) => dispatch(getMonitoreoDevice(filters));
  const initMonitoreoService = (filters) => dispatch(getMonitoreoService(filters));
  const initMonitoreoMetric = (filters) => dispatch(getMonitoreoMetric(filters));
  const dataMonitoreo = useSelector((state) => state.fuse?.monitoreo);
  const viewMonitoreo = useSelector((state) => state?.fuse?.monitoreo);
  const loaderMonitoreo = useSelector((state) => state?.fuse?.monitoreo?.loading);
  const filtersSelected = useSelector((state) => state?.fuse?.monitoreo?.filtersSelected);

  useEffect(() => {
    dispatch(getDashboardMetrics());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersSelected]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setRegion('');
      setInmueble('');
      setGrupo('');
      setDateInit();
      setDateEnd();
      dispatch(
        setMonitoreoFiltersSelected({
          tiempo: { fechaFin: 'update', fechaIni: 'update' },
        })
      );
    }, 60000 * 3);
    return () => {
      clearInterval(intervalId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchAllData = () => {
    dispatch(getNotifications({ idUser: id, roleId }));
    initMonitoreoService(filtersSelected);
    dispatch(getDashboardFirstSection(filtersSelected));
    initMonitoreoDevice(filtersSelected);
    initMonitoreoMetric(filtersSelected);
    dispatch(getDashboardCaidas(filtersSelected));
    dispatch(getDashboardResponseTime(filtersSelected));
    // if (Object.keys(filtersSelected).length > 0) {
    // } else {
    //   initMonitoreoService();
    //   dispatch(getDashboardFirstSection());
    //   initMonitoreoDevice();
    //   initMonitoreoMetric();
    // }
  };

  return (
    <>
      {viewMonitoreo?.error?.name === 'AxiosError' ? (
        <>
          <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Loader nameComponent="metrics" nameLabel="Metricas" loader={loaderMonitoreo} />
          </div>
        </>
      ) : (
        <>
          <div className="flex mb-4">
            <div className="w-full">
              <DashboardFilter
                currentFilters={{ inmueble, region, grupo, nodo, dateInit, dateEnd }}
                filtersSetters={{ setInmueble, setRegion, setGrupo, setNodo, setDateInit, setDateEnd }}
                filtersSelected={filtersSelected}
                setFilters={setMonitoreoFiltersSelected}
                fetchAllData={fetchAllData}
              />
              <HeaderDashboard filtersSelected={filtersSelected} redirect="/monitoreo" />
              <WrapperMonitoreo>
                <div className="standard-container flex flex-row gap-4">
                  <DevicesHigh {...dataMonitoreo} />
                  <Devices {...dataMonitoreo} />
                  <Metrics {...dataMonitoreo} />
                </div>
              </WrapperMonitoreo>
              <div className="standard-container flex flex-row gap-4">
                <div className="w-1/2">
                  <CaidasNodos />
                </div>
                <div className="w-1/2">
                  <TiempoRespuesta />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default Index;
